var SamplerState = (function () {
    function SamplerState() {
    }
    return SamplerState;
}());
export { SamplerState };



// WEBPACK FOOTER //
// ../dist/lib/base/SamplerState.js